/**
 * Press scale 0.97 + hover sutil en web (Square-ish).
 * No animar navegación de tabs — solo feedback de control.
 *
 * Hover NUNCA pisa `backgroundColor`: botones filled (Empezar/Hecho/No hay)
 * usan texto blanco; si el hover pasaba a brandSoft mint, el label desaparecía.
 */
import React from 'react';
import {
  Platform,
  Pressable,
  type PressableProps,
  type StyleProp,
  type ViewStyle,
} from 'react-native';
import { WEB_BUTTON_FOCUS_RESET } from './webButtonFocusReset';
import { ticketColors } from '../theme/public-api';

type SoftPressableProps = Omit<PressableProps, 'style'> & {
  style?: StyleProp<ViewStyle>;
  /** Soft lift on web hover (shadow + border). Default true. */
  hoverLift?: boolean;
  /** Scale 0.97 on press. Disable when press triggers layout shifts (e.g. expanding footer). */
  pressScale?: boolean;
};

const WEB_HOVER_LIFT: ViewStyle | null =
  Platform.OS === 'web'
    ? ({
        borderColor: ticketColors.brandBorderStrong,
        // RN-web accepts boxShadow on ViewStyle at runtime.
        boxShadow: '0 2px 8px rgba(28, 25, 23, 0.10)',
        transform: [{ translateY: -1 }],
      } as ViewStyle)
    : null;

export function SoftPressable({
  style,
  hoverLift = true,
  pressScale = true,
  children,
  ...rest
}: SoftPressableProps) {
  return (
    <Pressable
      {...rest}
      style={(state) => {
        const { pressed } = state;
        const hovered = Platform.OS === 'web' && Boolean((state as { hovered?: boolean }).hovered);
        return [
          WEB_BUTTON_FOCUS_RESET,
          style,
          hoverLift && hovered && !pressed ? WEB_HOVER_LIFT : null,
          pressScale && pressed ? ({ transform: [{ scale: 0.97 }] } as ViewStyle) : null,
        ];
      }}
    >
      {children}
    </Pressable>
  );
}
